import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Spinner } from 'react-bootstrap';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { user, loading, isAuthenticated, hasRole } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: "#f8fffe" }}>
        <div className="text-center">
          <Spinner animation="border" variant="primary" size="lg" />
          <p className="mt-3 text-muted">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated()) {
    // Redirect to login page with return url
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (requiredRole && !hasRole(requiredRole)) {
    // Redirect to appropriate dashboard based on user role
    if (hasRole('admin')) {
      return <Navigate to="/admin/dashboard" replace />;
    } else if (hasRole('doctor')) {
      return <Navigate to="/doctor/dashboard" replace />;
    } else if (hasRole('patient')) {
      return <Navigate to="/patient/dashboard" replace />;
    } else {
      return <Navigate to="/patient/login" replace />;
    }
  }

  return children;
};

export default ProtectedRoute; 